module.exports = __webpack_public_path__ + "img/checked.e0a6a0c8.svg";